var __rest = this && this.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
import MUILink from "@material-ui/core/Link";
import NextJSLink from "next/link";
import React from "react";
export { ActiveLink } from "./active";
export { ContrastLink } from "./contrast";
export { ImperceptibleLink } from "./imperceptible";
export var Link = function(_a) {
    var children = _a.children, className = _a.className, target = _a.target, rel = _a.rel, underline = _a.underline, rest = __rest(_a, [
        "children",
        "className",
        "target",
        "rel",
        "underline"
    ]);
    return /*#__PURE__*/ React.createElement(NextJSLink, Object.assign({
        passHref: true
    }, rest), /*#__PURE__*/ React.createElement(MUILink, {
        className: className,
        color: "inherit",
        target: target,
        rel: rel,
        underline: underline
    }, children));
};
export default Link;
